const locales: string[] = ['en-US', 'pt-PT'];
const localeDelimiter: string = "-";
const namespace: string = "common";

export { locales, localeDelimiter, namespace };
